module.exports = __webpack_public_path__ + "fwm_h5/img/phone.11f50bd0.png";